import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';

export const useFileUpload = () => {
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);

    // Fungsi untuk menghasilkan preview image
    const generatePreview = (file) => {
        const previewUrl = URL.createObjectURL(file); // Membuat URL preview dari file
        setPreview(previewUrl);
    };

    // Fungsi untuk membersihkan preview ketika file dihapus atau diubah
    const clearPreview = () => {
        if (preview) {
            URL.revokeObjectURL(preview); // Membersihkan URL preview
            setPreview(null);
            setFile(null);
        }
    };

    const setFileAndPreview = (acceptedFiles) => {
        setFile(acceptedFiles); // Set file yang dipilih
        clearPreview(); // Membersihkan preview
        generatePreview(acceptedFiles); // Membuat preview baru
    };

    const FileUpload = () => {
        const { getRootProps, getInputProps } = useDropzone({
            onDrop: acceptedFiles => setFileAndPreview(acceptedFiles[0]),
            accept: 'image/*',
        });

        return (
            <div
                {...getRootProps()}
                className="border border-secondary border-dashed rounded p-5 text-center"
                style={{ cursor: 'pointer' }}
            >
                <input {...getInputProps()} />
                <p className="text-muted">Drop files here to upload</p> {/* Teks di tengah */}
            </div>
        );
    };

    // Komponen untuk menampilkan file yang telah dipilih (preview)
    const FileSelectDisplay = () => (
        <div className="text-center">
            {file && preview && (
                <div className='border border-secondary border-dashed rounded p-5 text-center'>
                    <div
                        className="position-relative"
                        style={{ display: 'inline-block', width: '150px', height: '150px' }}
                    >
                        <img
                            src={preview}
                            alt="File Preview"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                        />
                        {/* Button close untuk menghapus file */}
                        <button
                            onClick={clearPreview}
                            style={{
                                position: 'absolute',
                                top: '5px',
                                right: '5px',
                                background: 'rgba(0, 0, 0, 0.5)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '24px',
                                height: '24px',
                                cursor: 'pointer',
                                fontSize: '16px',
                            }}
                        >
                            &times;
                        </button>
                    </div>
                </div>
            )}
        </div>
    );

    return { file, FileUpload, FileSelectDisplay };
};
